import drivingLicenseLogo from "../assets/svg/drivingLicenseLogo.svg";
import processingIcon from "../assets/svg/processingIcon.svg";
import warningStripIcon from "../assets/svg/warningStripIcon.svg";
import cancelStripeIcon from "../assets/svg/cancelStripeIcon.svg";
import latestGreenTick from "../assets/svg/latestGreenTick.svg";
const StripeAndManualDrivingLicense = ({
  verificationStripeURL,
  closeModal,
  stripeStatusCode,
  stripeStatusResponse,
  setStripeStatusCode
}) => {
  const redirectToLink = () => {
    window.location.href = verificationStripeURL;
    localStorage.setItem("isVerify", true);
  };

  return (
    <div>
      <div>
        <div className="text-center fontAntarctica">
          <div className="my-2">
            {stripeStatusCode === "" && (
              <img
                className="m-1"
                src={drivingLicenseLogo}
                alt="drivingLicenseLogo"
              />
            )}
            {stripeStatusCode === 1 && (
              <img className="m-1" src={processingIcon} alt="processingIcon" />
            )}
            {stripeStatusCode === 3 && (
              <img
                className="m-1"
                src={latestGreenTick}
                alt="latestGreenTick"
              />
            )}
            {stripeStatusCode === 4 && (
              <img
                className="m-1"
                src={cancelStripeIcon}
                alt="cancelStripeIcon"
              />
            )}
            {(stripeStatusCode === 5 || stripeStatusCode === 2) && (
              <img
                className="m-1"
                src={warningStripIcon}
                alt="warningStripIcon"
              />
            )}
          </div>
          <div className="my-3 mx-2 text-center">
            {stripeStatusCode === "" &&
              "Please verify your driver license to confirm the booking"}
            {stripeStatusCode === 1 && "Thank you"}
            {stripeStatusCode === 3 && "Thank you"}
            {stripeStatusCode === 4 && "Oops, verification didn't go through!"}
            {(stripeStatusCode === 5 || stripeStatusCode === 2) &&
              "Oops, looks like the verification didn't quite make it through!"}
          </div>
          <div className="my-2 mx-5 fontColor5BD">
            {stripeStatusCode === "" && 
             "To book a vehicle, a driver license is required. This will only take a minute." }
             {stripeStatusCode === 1 && 
             "We'll have your license verification sorted out real soon." }
              {stripeStatusCode === 2 && 
             "Are you certain you are verifying the valid driver's license?" }
             {stripeStatusCode === 3 && 
             "Your license has been successfully verified." }
             {stripeStatusCode === 4 && 
             "Are you certain you are verifying the valid driver's license?" }
             {stripeStatusCode === 5 && 
             stripeStatusResponse}

          </div>
          {stripeStatusCode === "" &&
          <button
            onClick={redirectToLink}
            className="my-2 bgCE1 text-white p-2 border-0 outlineNone borderRadius8 text-center w-100"
          >
            Verify your Identity
          </button>
}
          {stripeStatusCode === "" && (
            <div
              onClick={() => {
                closeModal("StripeDrivingLicenseModal");
                localStorage.removeItem("verificationSessionId");
                localStorage.removeItem("isVerify");
              }}
              className="my-2 cursorPointer fontColor5BD"
            >
              I will do it later
            </div>
          )}
          {(stripeStatusCode === 1 || stripeStatusCode === 3) && (
            <button
              onClick={() => {
                closeModal("StripeDrivingLicenseModal");
                localStorage.removeItem("verificationSessionId");
                localStorage.removeItem("isVerify");
                setStripeStatusCode("");
              }}
              className="my-2 bgCE1 text-white p-2 border-0 outlineNone borderRadius8 text-center w-100"
            >
              Continue
            </button>
          )}

          {(stripeStatusCode === 4 || stripeStatusCode === 5  || stripeStatusCode === 2) && (
            <button onClick={redirectToLink} className="my-2 bgCE1 text-white p-2 border-0 outlineNone borderRadius8 text-center w-100">
              Retry
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default StripeAndManualDrivingLicense;
